import { ChatEmoji, ChatEmojiCategory, ChatEmojiData } from '../model/chat-emoji';
import { getEmojiKey } from './chat-emoji-key';

function mergeCategoryEmojis(baseEmojis: ChatEmoji[], customEmojis: ChatEmoji[]): ChatEmoji[]
{
  const merged = [...baseEmojis];
  const indexByIdentity = new Map<string, number>();

  merged.forEach((emoji, index) =>
  {
    const identity = getEmojiKey(emoji);
    if (identity)
    {
      indexByIdentity.set(identity, index);
    }
  });

  customEmojis.forEach((emoji) =>
  {
    const identity = getEmojiKey(emoji);

    if (identity && indexByIdentity.has(identity))
    {
      merged[indexByIdentity.get(identity)] = emoji;
      return;
    }

    if (identity)
    {
      indexByIdentity.set(identity, merged.length);
    }

    merged.push(emoji);
  });

  return merged;
}

/** Merges optional client emoji data into the base catalog (custom wins on duplicate ids/chars). */
export function mergeEmojiData(base: ChatEmojiData, custom: ChatEmojiData): ChatEmojiData
{
  const categories = base.categories.map((category) => ({
    ...category,
    emojis: [...category.emojis]
  }));
  const categoryById = new Map(categories.map((category) => [category.id, category]));

  custom.categories.forEach((customCategory) =>
  {
    const existing = categoryById.get(customCategory.id);

    if (existing)
    {
      existing.emojis = mergeCategoryEmojis(existing.emojis, customCategory.emojis);
      return;
    }

    const newCategory: ChatEmojiCategory = {
      ...customCategory,
      emojis: [...customCategory.emojis]
    };
    categories.push(newCategory);
    categoryById.set(newCategory.id, newCategory);
  });

  return {
    version: base.version,
    categories
  };
}
